const styles = {
  autocomplete: { backgroundColor: "white", mb: 3 },
};

export default styles;
